/* eslint-disable react/jsx-no-duplicate-props */
/* eslint-disable react/prop-types */
import React, { useEffect, useState } from "react";
import { Box, Typography, Grid } from "@mui/material";

import Footer from "./footer";
import SoftSelect from "components/SoftSelect";
import SoftButton from "components/SoftButton";
import SoftBox from "components/SoftBox";
import Dropdown from "./dropdown";

const tableStyle = {
  borderCollapse: "collapse",
  width: "100%",
};

const thTdStyle = {
  border: "1px solid black",
  textAlign: "left",
  padding: "8px",
  fontWeight: 400,
  background: "#ddeff3",
  textAlign: "center",
};

const Th = ({ children, styles, ...rest }) => {
  return (
    <th {...rest} style={{ ...thTdStyle, ...styles, fontSize: "14px " }}>
      {children}
    </th>
  );
};
const Td = ({ children, style, row, ...rest }) => {
  return (
    <th
      {...rest}
      style={{ ...thTdStyle, ...style, fontWeight: row.bold ? "bold" : 400, fontSize: "14px" }}
    >
      {children}
    </th>
  );
};
const defaultOption = [
  {
    value: "title",
    label: "title",
    disabled: true,
  },
];

const billTypeNameOption = [
  {
    value: "Thuế suất 0%",
    label: "Thuế suất 0%",
    disabled: false,
  },
  {
    value: "Thuế suất 5%",
    label: "Thuế suất 5%",
    disabled: false,
  },
  {
    value: "Thuế suất 8%",
    label: "Thuế suất 8%",
    disabled: false,
  },
  {
    value: "Thuế suất 10%",
    label: "Thuế suất 10%",
    disabled: false,
  },
  {
    value: "Không chiụ thuế GTGT",
    label: "Không chiụ thuế GTGT",
    disabled: false,
  },
  {
    value: "Không kê khai,tính nộp thuế GTGT",
    label: "Không kê khai,tính nộp thuế GTGT",
    disabled: false,
  },

  {
    value: "Trường hợp khác",
    label: "Trường hợp khác",
    disabled: false,
  },
];

const noteOption = [
  {
    value: "Hóa đơn chưa TBPH",
    label: "Hóa đơn chưa TBPH",
    disabled: false,
  },
  {
    value: "Hóa đơn chưa sử dụng",
    label: "Hóa đơn chưa sử dụng",
    disabled: false,
  },
  {
    value: "Hóa đơn đã viết chưa báo cáo sử dụng",
    label: "Hóa đơn đã viết chưa báo cáo sử dụng",
    disabled: false,
  },
  {
    value: "Hóa đơn đã viết và đã báo cáo sử dụng kỳ trước",
    label: "Hóa đơn đã viết và đã báo cáo sử dụng kỳ trước",
    disabled: false,
  },
  {
    value: "Hóa đơn mua hàng",
    label: "Hóa đơn mua hàng",
    disabled: false,
  },
];

const dataTable = [
  {
    onlyTitle: true,
    bold: true,
    id: {
      value: 1,
      bg: true,
    },
    billTypeName: {
      type: "select",
      value: null,
      bg: false,
      option: billTypeNameOption,
    },
    symbol: {
      type: "input",
      value: null,
      bg: false,
    },
    symbolBill: {
      type: "input",
      value: null,
      bg: false,
    },
    numberBill: {
      type: "input",
      value: null,
      bg: false,
    },
    date: {
      type: "input",
      value: null,
      bg: false,
    },
    buyer: {
      type: "input",
      value: null,
      bg: false,
    },
    mstBuyer: {
      type: "input",
      value: null,
      bg: false,
    },
    revenue: {
      type: "input",
      value: null,
      bg: false,
    },
    gtgtTax: {
      type: "input",
      value: null,
      bg: false,
    },

    note: {
      type: "input",
      value: null,
      bg: false,
    },
  },
];
export default function Bill03Table({ formData, setFieldValue }) {
  const [data, setData] = useState(dataTable);

  useEffect(() => {
    setFieldValue("valuesTable", data);
  }, [data]);

  const getMaxIdValue = () => {
    return Math.max(...data.map((item) => item.id.value), 0);
  };

  const addNewRow = () => {
    const newIdValue = getMaxIdValue() + 1;
    const newRow = {
      onlyTitle: true,
      bold: true,
      id: {
        value: newIdValue,
        bg: true,
      },
      billTypeName: {
        type: "select",
        value: null,
        bg: false,
        option: billTypeNameOption,
      },
      symbol: {
        type: "input",
        value: null,
        bg: false,
      },
      symbolBill: {
        type: "input",
        value: null,
        bg: false,
      },
      numberBill: {
        type: "input",
        value: null,
        bg: false,
      },
      date: {
        type: "input",
        value: null,
        bg: false,
      },
      buyer: {
        type: "input",
        value: null,
        bg: false,
      },
      mstBuyer: {
        type: "input",
        value: null,
        bg: false,
      },
      revenue: {
        type: "input",
        value: null,
        bg: false,
      },
      gtgtTax: {
        type: "input",
        value: null,
        bg: false,
      },

      note: {
        type: "input",
        value: null,
        bg: false,
      },
    };
    setData((prev) => [...prev, newRow]);
  };

  const removeRow = () => {
    if (data.length !== 1) {
      data.pop();
      const newRow = data;
      setData([...newRow]);
    }
  };

  const handleChange = (values) => {
    const { id, name, value } = values;
    setData((prev) =>
      prev.map((item) => {
        if (item.id.value === id) {
          return { ...item, [name]: { ...item[name], value } };
        }
        return item;
      })
    );
  };

  return (
    <Box display="flex" flexDirection="column" mt={5}>
      <Box>
        <table style={tableStyle}>
          <thead>
            <tr>
              <Th style={{ textAlign: "center" }} rowSpan="2">
                STT
              </Th>
              <Th style={{ textAlign: "center" }} colSpan="5">
                Hóa đơn, chứng từ bán ra
              </Th>
              <Th style={{ textAlign: "center" }} rowSpan="2">
                Tên người mua
              </Th>
              <Th style={{ textAlign: "center" }} rowSpan="2">
                Mã số thuế người mua
              </Th>
              <Th style={{ textAlign: "center" }} rowSpan="2">
                Doanh thu chưa có thuế GTGT
              </Th>
              <Th style={{ textAlign: "center" }} rowSpan="2">
                Thuế GTGT
              </Th>
              <Th style={{ textAlign: "center" }} rowSpan="2">
                GHI CHÚ
              </Th>
            </tr>
            <tr>
              <Th style={{ textAlign: "center" }} styles={{ width: "15%" }}>
                Tên loại hóa đơn
              </Th>
              <Th style={{ textAlign: "center" }}>Ký hiệu mẫu số hóa đơn/ Thuế suất</Th>
              <Th style={{ textAlign: "center" }}>Ký hiệu hóa đơn</Th>
              <Th style={{ textAlign: "center" }}>Số hóa đơn</Th>
              <Th style={{ textAlign: "center" }}>Ngày tháng năm lập hóa đơn</Th>
            </tr>
            <tr>
              <Th style={{ textAlign: "center" }}>(1)</Th>
              <Th style={{ textAlign: "center" }}>(2)</Th>
              <Th style={{ textAlign: "center" }}>(3)</Th>
              <Th style={{ textAlign: "center" }}>(4)</Th>
              <Th style={{ textAlign: "center" }}>(5)</Th>
              <Th style={{ textAlign: "center" }}>(6)</Th>
              <Th style={{ textAlign: "center" }}>(7)</Th>
              <Th style={{ textAlign: "center" }}>(8)</Th>
              <Th style={{ textAlign: "center" }}>(9)</Th>
              <Th style={{ textAlign: "center" }}>(10)</Th>
              <Th style={{ textAlign: "center" }}>(11)</Th>
            </tr>
          </thead>
          <tbody>
            {data &&
              data.length > 0 &&
              data.map((row, index) => (
                <tr key={row.id.value + index}>
                  <Td
                    row={""}
                    style={{
                      textAlign: "center",
                      background: "transparent",
                    }}
                  >
                    {row?.id?.value}
                  </Td>

                  <Td
                    row={row}
                    style={{
                      textAlign: "left",
                      background: !row.billTypeName.bg ? "transparent" : "#ddeff3",
                    }}
                  >
                    {row.billTypeName.bg ? (
                      row.billTypeName.value
                    ) : row.billTypeName?.type === "select" ? (
                      <SelectTable
                        name="billTypeName"
                        id={row.id.value}
                        option={row.billTypeName.option ? row.billTypeName.option : defaultOption}
                        onSelect={handleChange}
                      />
                    ) : (
                      <InputTable
                        id={row.id.value}
                        name="billTypeName"
                        value={row.billTypeName.value}
                        onChange={handleChange}
                      />
                    )}
                  </Td>

                  <Td
                    row={row}
                    style={{
                      textAlign: "right",
                      background: !row.symbol.bg ? "transparent" : "#ddeff3",
                    }}
                  >
                    {row.symbol?.type !== "input" ? (
                      row.symbol.value
                    ) : (
                      <InputTable
                        type={"text"}
                        id={row.id.value}
                        name="symbol"
                        value={row.symbol.value}
                        onChange={handleChange}
                      />
                    )}
                  </Td>

                  <Td
                    row={row}
                    style={{
                      textAlign: "right",
                      background: !row.symbolBill.bg ? "transparent" : "#ddeff3",
                    }}
                  >
                    {row.symbolBill?.type !== "input" ? (
                      row.symbolBill.value
                    ) : (
                      <InputTable
                        type={"text"}
                        id={row.id.value}
                        name="symbolBill"
                        value={row.symbolBill.value}
                        onChange={handleChange}
                      />
                    )}
                  </Td>

                  <Td
                    row={row}
                    style={{
                      textAlign: "right",
                      background: !row.numberBill.bg ? "transparent" : "#ddeff3",
                    }}
                  >
                    {row.numberBill?.type !== "input" ? (
                      row.numberBill.value
                    ) : (
                      <InputTable
                        type={"text"}
                        id={row.id.value}
                        name="numberBill"
                        value={row.numberBill.value}
                        onChange={handleChange}
                      />
                    )}
                  </Td>

                  <Td
                    row={row}
                    style={{
                      textAlign: "right",
                      background: !row.date.bg ? "transparent" : "#ddeff3",
                    }}
                  >
                    {row.date?.type !== "input" ? (
                      row.date.value
                    ) : (
                      <InputTable
                        fields={"date"}
                        type={"text"}
                        id={row.id.value}
                        name="date"
                        value={row.date.value}
                        onChange={handleChange}
                      />
                    )}
                  </Td>

                  <Td
                    row={row}
                    style={{
                      textAlign: "right",
                      background: !row.buyer.bg ? "transparent" : "#ddeff3",
                    }}
                  >
                    {row.buyer?.type !== "input" ? (
                      row.buyer.value
                    ) : (
                      <InputTable
                        type={"text"}
                        id={row.id.value}
                        name="buyer"
                        value={row.buyer.value}
                        onChange={handleChange}
                      />
                    )}
                  </Td>

                  <Td
                    row={row}
                    style={{
                      textAlign: "right",
                      background: !row.mstBuyer.bg ? "transparent" : "#ddeff3",
                    }}
                  >
                    {row.mstBuyer?.type !== "input" ? (
                      row.mstBuyer.value
                    ) : (
                      <InputTable
                        type={"text"}
                        id={row.id.value}
                        name="mstBuyer"
                        value={row.mstBuyer.value}
                        onChange={handleChange}
                      />
                    )}
                  </Td>

                  <Td
                    row={row}
                    style={{
                      textAlign: "right",
                      background: !row.revenue.bg ? "transparent" : "#ddeff3",
                    }}
                  >
                    {row.revenue?.type !== "input" ? (
                      row.revenue.value
                    ) : (
                      <InputTable
                        type={"text"}
                        id={row.id.value}
                        name="revenue"
                        value={row.revenue.value}
                        onChange={handleChange}
                      />
                    )}
                  </Td>

                  <Td
                    row={row}
                    style={{
                      textAlign: "right",
                      background: !row.gtgtTax.bg ? "transparent" : "#ddeff3",
                    }}
                  >
                    {row.gtgtTax?.type !== "input" ? (
                      row.gtgtTax.value
                    ) : (
                      <InputTable
                        type={"text"}
                        id={row.id.value}
                        name="gtgtTax"
                        value={row.gtgtTax.value}
                        onChange={handleChange}
                      />
                    )}
                  </Td>

                  <Td
                    row={row}
                    style={{
                      textAlign: "right",
                      background: !row.note.bg ? "transparent" : "#ddeff3",
                    }}
                  >
                    {row.note?.type !== "input" ? (
                      row.note.value
                    ) : (
                      <InputTable
                        type={"text"}
                        id={row.id.value}
                        name="note"
                        value={row.note.value}
                        onChange={handleChange}
                      />
                    )}
                  </Td>
                </tr>
              ))}
            <tr>
              <Td
                colspan="8"
                row={{ bold: true }}
                style={{
                  textAlign: "right",
                  paddingRight: "30px",
                  background: "#ddeff3",
                }}
              >
                Tổng doanh thu hàng hóa, dịch vụ bán ra chịu thuế GTGT (*):
              </Td>
              <Td
                colspan="2"
                row={{ bold: true }}
                style={{
                  textAlign: "right",
                  background: "#ddeff3",
                }}
              >
                0
              </Td>
              <Td
                row={{ bold: true }}
                style={{
                  textAlign: "right",
                  background: "#ddeff3",
                }}
              ></Td>
            </tr>
            <tr>
              <Td
                colspan="8"
                row={{ bold: true }}
                style={{
                  textAlign: "right",
                  paddingRight: "78px",
                  background: "#ddeff3",
                }}
              >
                Tổng số thuế GTGT của hàng hóa, dịch vụ bán ra (**):
              </Td>
              <Td
                colspan="2"
                row={{ bold: true }}
                style={{
                  textAlign: "right",
                  background: "#ddeff3",
                }}
              >
                0
              </Td>
              <Td
                row={{ bold: true }}
                style={{
                  textAlign: "right",
                  background: "#ddeff3",
                }}
              ></Td>
            </tr>
          </tbody>
        </table>
        <SoftBox display="flex" justifyContent="flex-start" gap={3} mt={2}>
          <SoftButton variant="gradient" color="dark" onClick={addNewRow}>
            Thêm dòng
          </SoftButton>
          <SoftButton variant="gradient" color="light" onClick={removeRow}>
            Xóa dòng
          </SoftButton>
        </SoftBox>
        <Footer formData={formData} />
      </Box>
    </Box>
  );
}

function InputTable(props) {
  const { id, onChange, type, fields, ...rest } = props;
  const regexNumber = /^(0|[1-9]\d*)?$/;
  function handleChange(event) {
    const { name, value } = event.target;
    const newValue = value;
    if (type == "number") {
      if (!regexNumber.test(newValue)) return;
      onChange({ id, value: newValue !== "" ? +newValue : "", name });
    } else if (type == "decimal") {
      if (!regexDecimal.test(newValue)) return;
      onChange({ id, value: newValue, name });
    } else {
      onChange({ id, value: newValue !== "" ? newValue : "", name });
    }
  }
  return (
    <input
      style={{
        textAlign: type === "number" ? "right" : "left",
        fontSize: 16,
        color: "#344767",
        border: "none",
        background: "transparent",
        padding: "4px 4px 4px 4px",
        width: "100%",
      }}
      onChange={handleChange}
      type={fields}
      {...rest}
    />
  );
}

function SelectTable(props) {
  const { id, onSelect, type, option, name, style, ...rest } = props;
  const [newValue, setNewValue] = useState();
  useEffect(() => {
    if (typeof onSelect === "function") {
      onSelect({ id, value: newValue !== "" ? newValue : "", name });
    }
  }, [newValue]);
  return (
    <div style={style}>
      <Dropdown option={option} id={id} newValue={newValue} setNewValue={setNewValue} />
    </div>
  );
}
